import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
// import 'amfe-flexible'
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css';
import VueJsonp from 'vue-jsonp'
import echarts from 'echarts'


Vue.prototype.$echarts = echarts
Vue.use(VueJsonp)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(Vant) 

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
